<style scoped>
@media (min-width: 1200px) {

  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    max-width: 1320px;
  }
}

/*live graph css start*/
/*start live section css*/
.live-section {
  background-color: #fffdea;
  height: 33vh;
  margin: 0 auto;
  text-align: center;
}

/*main graph*/
.live-graph-wrpr {
  /*background: url("../../../../public/themeV2/BG.jpg");*/
  /*background-repeat: no-repeat;*/
  /*background-size: cover;*/
  /*height: 700px;*/
  justify-content: center;
  align-items: center;
  display: flex;
}

.graphTabs ul#pills-tab {
  display: flex;
}

.graphTabs ul#pills-tab li.nav-item button {
  width: 100%;
  height: 52px;
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;
  color: #282828;
}

.graphTabs ul#pills-tab li.nav-item {
  flex: 1;
}

.graphTabs ul#pills-tab li.nav-item .nav-link {
  background-color: aliceblue;
  border-radius: 0;
}

.graphTabs ul#pills-tab li.nav-item .nav-link.active {
  background: #fcb913;
}

.live-graph-wrpr .div-flex {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.btn-select {
  padding: 60px 30px;
}

.btn-select ul li {
  box-sizing: border-box;
  width: 130px;
  height: 100px;
  border: 3px solid transparent;
  background-image: url("../../../../public/themeV2/assets/images/bg-men.png");
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.btn-select ul li:hover {
  border: 3px solid #00b4e3;
}

.btn-select ul li a {
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}

.live-content {
  padding: 33px;
  width: 100%;
}

.live-content h1 {
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 39px;

  color: #000000;
}

.live-content p {
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;

  color: #000000;
}

.div-flex-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* .div-flex-row .colm-left {
  width: 50%;
} */

.div-flex-row .colm-right {
  display: flex;
  align-items: center;
  justify-content: center;
}

.div-flex-row label {
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  align-items: center;
  text-align: center;
  color: #000000;
  margin: 0 12px;
}

.div-flex-row span.live-badge {
  background: #ef0000;
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
  padding: 7px 21px;
  display: inline-block;
  text-align: center;
  margin: 0 12px;
}

.div-flex-row span.dis-badge {
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  align-items: center;
  text-align: center;
  background-color: #000000;
  color: #ffffff;
  padding: 7px 21px;
  display: inline-block;
  text-align: center;
  margin: 0 12px;
}

/*load more button*/
.load-btn-wrpr {
  margin: 0 auto;
  text-align: center;
  margin: 100px auto;
}

.loadmore {
  border: 1px solid #e1e1e1;
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  display: inline-block;
  align-items: center;
  text-align: center;
  letter-spacing: 0.0125em;
  color: #000000;
  background-color: #fff;
  margin: 0 6px;
  padding: 12px 40px;
  cursor: pointer;
  min-width: 144px;
  -webkit-transition: all 1.5s;
  -moz-transition: all 1.5s;
  transition: all 1.5s;
}

.loadmore:hover {
  background: #fcb913;
  color: #000000 !important;
}

.btn-select li.active {
  border: 3px solid #00b4e3;
}

#p5Canvas {
  background: white;
}
</style>

<template>
  <div class="live-graph-wrpr">
    <div class="container">
      <div class="div-flex">
        <div class="btn-select" :class="`d-none`">
          <ul>
            <li class="active"><a>DUMMY EVENT</a></li>
          </ul>
        </div>
        <div class="live-content">
          <div class="div-flex-row">
            <div class="colm-left">
              <h2>Results / Live Stats / {{ eventName }}</h2>
            </div>
            <!--<div class="colm-right">
              <label>VIEW</label>
              <span class="live-badge div-flex">
                <span class="ring-container">
                  <span class="ringring"></span>
                  <span class="circle"></span>
                </span>
  <img src="../../../../public/themeV2/assets/images/circle-white.png"/>
                <span class="ml-3">LIVE</span>
              </span>
              <span class="dis-badge">{{ event.distance || 0 }} km</span>
            </div>-->
          </div>
          <div class="graph-wrper">
            <div class="container">
              <div class="d-flex justify-content-center" id="p5Canvas"></div>
            </div>
          </div>
        </div>
      </div>

      <!--<div class="graphTabs">
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
                    type="button" role="tab" aria-controls="pills-home" aria-selected="true">Sunday Race Club - Men
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
                    type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Sunday Race Club -
              Women
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact"
                    type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Sunday Race Club -
              Women
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact"
                    type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Sunday Race Club -
              Women
            </button>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">...</div>
          <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">...</div>
          <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">...</div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { LiveGraphCanvas } from "./chart";
import { mapActions } from "vuex";

export default {
  name: "LiveEventCanvas",
  props: [
    "event",
    "eventName",
    "spectatorPlayer",
    "selectedDayId",
    "graphElevationValues",
  ],
  computed: {
    // ...mapGetters("player", ["playersRideData"]),
  },
  data() {
    return {
      eventId: this.$route.query.eventId || null,
      lPlayer: null,
      rideData: [],
    };
  },
  async mounted() {
    // this.rideData = this.playersRideData
    this.rideDataTopic = `event:ride:${this.eventId}`;
    await this.loadGraph();
    this.getRiderData();
  },
  watch: {
    spectatorPlayer(player) {
      this.lPlayer = player;
    },
  },
  methods: {
    ...mapActions("player", ["getLiveRidersData"]),

    async loadGraph() {
      // generate TEST data
      // this.drawRidersData(5, 1000);

      const Chart = require("p5");
      new Chart((sk) =>
        LiveGraphCanvas(sk, () => ({
          eventData: this.event,
          rideData: this.rideData,
          // rideDataTopic: this.rideDataTopic,
          spectatorPlayer: this.lPlayer,
          // spectatorPlayer: { userId: "user-10" },
          elevationValues: this.graphElevationValues,
          distance:
            this.event.routeDistances.find(
              (x) => x.DayId === this.selectedDayId
            )?.distance || 0,
        }))
      );
    },

    // drawRidersData(countUsers = 10, duration = 5000) {
    //   // Function to generate a random number between min (inclusive) and max (exclusive)
    //   function getRandomArbitrary(min, max) {
    //     return Math.random() * (max - min) + min;
    //   }

    //   // Array to store distances for each rider
    //   var distances = [];

    //   // Generate random distances for 100 riders
    //   for (var i = 0; i < countUsers; i++) {
    //     // Generate random speed between 10 and 30 km/h
    //     var speed = getRandomArbitrary(40, 50);
    //     // Initialize distance to 0
    //     var distance = 0;
    //     // Calculate time using distance = speed * time, rearranging to time = distance / speed
    //     var time = 0;
    //     // Store the distance, speed, and time for this rider
    //     distances.push({
    //       speed: speed,
    //       time: time,
    //       Elevation: 0,
    //       OldDistance: 0,
    //       NewDistance: distance,
    //       UserId: `user-${i + 1}`,
    //     });
    //   }

    //   // Call the updateDistances function every 5 seconds
    //   setInterval(() => {
    //     // Update distance for each rider
    //     distances.forEach(function (rider) {
    //       // update old distance
    //       rider.OldDistance = rider.NewDistance,
    //         // Increment distance based on speed
    //         rider.NewDistance += (rider.speed / 3600) * 5; // Convert speed from km/h to km/s
    //       // Update time
    //       rider.time += 50;
    //     });
    //     // Output the updated distances
    //     // console.log(distances);

    //     this.rideData = distances;
    //   }, duration);
    // },

    getRiderData() {
      setInterval(async () => {
        const res = await this.getLiveRidersData({ eventId: this.eventId });
        this.rideData = res.data;
      }, 5000);
    },
  },
};
</script>
